module.exports = __webpack_public_path__ + "assets/img/experience-5.19091749.svg";